export const benefits = {
  BT_STAY_FAST_GUARANTEE: {
    mainText: "Stay Fast Guarantee - get the speeds we promise you, or £20 back"
  },
  BT_CONNECTED_PROMISE: {
    mainText:
      "Plus benefit: Our Keep Connected Promise, getting you back online quickly if your broadband stops working"
  },
  BT_DOUBLE_DATA: {
    mainText: "Plus benefit: Double data for mobiles on a Plus account"
  },
  BT_UNLIMITED_USAGE: {
    mainText: "Unlimited monthly usage"
  },
  BT_SMART_HUB: {
    mainText:
      "Smart Hub – more powerful than the hubs from other big broadband providers"
  },
  BT_VIRUS: {
    mainText: "BT Virus Protect on 2 devices and Parental controls"
  },
  BT_BROADBAND: {
    mainText: "No broadband price rises in 2019"
  },
  BT_PLACEHOLDER: {
    mainText:
      "<span class='bold'>PLACEHOLDER</span> - this is a story all about how"
  },
  BT_EXPERT_SERVICE: {
    mainText:
      "<span class='bold'>Brilliant, expert service</span> - You'll always speak to one of our team based in the UK and Ireland. "
  },
  BT_SPEED_GUARANTEE: {
    mainText:
      "<span class='bold'>Speed guarantee</span> - Speeds you can rely on day and night, and a personal speed guarantee."
  },
  BT_POWERFUL_HUB: {
    mainText:
      "<span class='bold'>The UK's most powerful hub</span> - Smart Hubs: more powerful than other big providers and Which? Best Buys."
  },
  BT_UNRIVALLED_SECURITY: {
    mainText:
      "<span class='bold'>Unrivalled security</span> - More online security features included than with other big providers."
  },
  BT_EXPERT_TECH_SUPPORT: {
    mainText:
      "<span class='bold'>Expert tech support in your own home</span> - More than simply engineers, our Home Tech Experts bring brilliant technical knowhow straight to your door."
  },
  BT_MANAGE_SCREEN_TIME: {
    mainText:
      "<span class='bold'>Manage screen time with our latest smart hub, worth £100</span> - Our Smart 2 comes with Wi-Fi controls, so you can pause the internet and manage your family's screen time."
  },
  BT_KEEP_CONNECTED: {
    mainText:
      "<span class='bold>Our keep connected promise</span> - Problem with your broadband? Moving home? We'll send you a 4g Mini Hub straight away to get you back online quickly."
  },
  BT_DOUBLE_DATA_2: {
    mainText:
      "<span class='bold'>Double mobile data</span> - Got mobile with us? We'll double your data, every month, and you can share your benefits with everyone at home who's got mobile with us."
  },
  BT_PRICE_PROMISE: {
    mainText:
      "<span class='bold'>Our price promise</span> - Your bill won't go up when your contract ends, and you'll never pay more than a new customer."
  },
  BT_INSTANT_ON_PLACEHOLDER: {
    mainText:
      "<span class='bold'>Instant connection</span> - We send your kit the day after you order and you can get connected to 4G straight away for no extra cost whilst our engineers set up your broadband."
  },
  BT_ALWAYS_ON: {
    mainText:
      "<span class='bold'>Always On</span> - Two networks are more reliable than one. Our clever home Wi-Fi and mobile networks work together to give you a connection that's always on, and always reliable"
  },
  BT_COMPLETE_WIFI: {
    mainText:
      "<span class='bold'>Complete Wi-Fi</span> - Complete Wi-Fi uses Wi-Fi Discs to extend your hub's signal to every corner of your home, whatever size and shape it is. And we don't just guarantee you'll get a Wi-Fi signal in every room. We'll give you a faster Wi-Fi guarantee than any other provider"
  }
}
